/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import BigNumber from 'bignumber.js';

export interface IDialogState {
  currentModal?: string;
  context?: unknown;
  amount?: BigNumber;
}

interface IRootState {
  dialog: IDialogState;
}

const initialState: IDialogState = {};

export const dialogSlice = createSlice({
  name: 'dialog',
  initialState,
  reducers: {
    openDialog: (state, action: PayloadAction<IDialogState>) => {
      state.currentModal = action.payload.currentModal;
      state.context = action.payload.context;
      state.amount = action.payload.amount;
    },
    closeDialog: state => {
      state.currentModal = undefined;
      state.context = undefined;
      state.amount = undefined;
    },
  },
});

export const selectDialogState = (state: IRootState) => state.dialog;

export const { openDialog, closeDialog } = dialogSlice.actions;
